<span class="dropdown-menu-item__content"><ng-content></ng-content></span>
